import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import Titulo from "../components/referidos/titulo";
import FormularioSwitch from "../components/referidos/formulario/switch";
import Footer from "../components/footer/index";
import Headroom from "react-headroom";
import { useSEO } from "../hooks/useSEO";
import TitleSection from "../components/TitleSection";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);
  overflow: hidden;
`;

export default function ReferidosContainer() {
  // Scroll ni bien carga la página
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  useSEO({
    title: "SeguroBici - Referidos",
    description: "¡Podes referir personas y ganar hasta $4000 por cada referido! Sin ningún tope de ganancias.",
  })

  return (
    <Container>
      {/* Canonical VivoMarketing */}
      <head>
        <link rel="canonical" href="https://segurobici.com.ar/referidos" />
      </head>
      {/* Header */}
      <Headroom>
        <Header></Header>
      </Headroom>
      <TitleSection tituloSpan="Referidos" tag="Promo" descripcion="¡Referí a tus amigos!"></TitleSection>
      {/* Formulario */}
      <FormularioSwitch></FormularioSwitch>
      {/* Footer */}
      <Footer marcas="active" pagina="institucional"></Footer>
    </Container>
  );
}
